window.util = window.util || {};

window.util.async_image_loader = {
  load() {
    $('[src-nx]').each((i, el) => {
      const image = $(el).attr('src-nx');
      $(el).attr('src', image);
    });

    $('[bg-xx]').each((i, el) => {
      const image = $(el).attr('bg-xx');
      $(el).css('background-image', `url(${image})`);
    });

    if (window.util.isRetina()) {
      $('[src-2x]').each((i, el) => {
        const image = $(el).attr('src-2x');
        $(el).attr('src', image);
      });

      $('[bg-2x]').each((i, el) => {
        const image = $(el).attr('bg-2x');
        $(el).css('background-image', `url(${image})`);
      });
    } else {
      $('[src-1x]').each((i, el) => {
        const image = $(el).attr('src-1x');
        $(el).attr('src', image);
      });

      $('[bg-1x]').each((i, el) => {
        const image = $(el).attr('bg-1x');
        $(el).css('background-image', `url(${image})`);
      });
    }

    $('[bg-lazy]').each((i, el) => {
      const $w = $(window);
      const $el = $(el);
      const THRESHOLD = 600;

      $el.one('unveil', () => {
        const source = $el.attr('bg-lazy');

        if (source) {
          $el.css('background-image', `url(${source})`);
        }
      });

      function unveil() {
        if ($el.is(':hidden')) {
          return;
        }

        const winTop = $w.scrollTop();
        const winBottom = winTop + $w.height();
        const elTop = $el.offset().top;
        const elBottom = elTop + $el.height();

        const isInView = elBottom >= winTop - THRESHOLD && elTop <= winBottom + THRESHOLD;

        if (isInView) {
          $el.trigger('unveil');
        }
      }

      $w.on('scroll.unveil resize.unveil lookup.unveil', unveil);

      unveil();
    });
  },
};



// WEBPACK FOOTER //
// ../utilities/async-image-loader.js